<template>
	<v-dialog :fullscreen="isMobile" v-if="addToCalendarModalOpen" v-model="addToCalendarModalOpen" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title class="headline modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="addToCalendarModalOpen=false"><v-icon large>fal fa-times</v-icon></button>
			</v-card-title>
			<v-card-text class="pa-5 pt-0 modal__card-text">
				<div class="text-xs-center">
					<i class="info--text fal fa-calendar-plus" style="font-size: 5em;"></i>
					<div style="font-size: 1.5em;" class="info--text mb-3">
						Add this event to your calendar
					</div>
					<v-btn class="info" @click="select(calendars[0])">{{calendars[0].text}}</v-btn>
					<v-btn class="info" @click="select(calendars[1])">{{calendars[1].text}}</v-btn>
					<v-btn class="info" @click="select(calendars[2])">{{calendars[2].text}}</v-btn>
					<v-btn class="info" @click="select(calendars[3])">{{calendars[3].text}}</v-btn>
				</div>
				<div>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { ics } from '~/plugins/ics'
export default {
	name: 'addToCalendarModal',
	data() {
		return {
			showMenu: false,
			x: 0,
			y: 0,
			calendars: [
				{
					text: 'Google',
					id: 'google',
					url: 'http://www.google.com/calendar/event?'
				},
				{
					text: 'Outlook',
					id: 'microsoft',
					url: 'http://calendar.live.com/calendar/calendar.aspx?rru=addevent&'
				},
				{
					text: 'Yahoo',
					id: 'yahoo',
					url: 'http://calendar.yahoo.com/?v=60&'
				},
				{
					text: 'Apple',
					id: 'apple',
					url: ''
				}
			]
		}
	},
	methods: {
		...mapActions(['setModalOpen', 'setSnackbarOpen', 'setSnackbarText']),
		select(calendar) {
			let url
			let urlTitle = encodeURIComponent(this.title)
			let urlDescription = encodeURIComponent(this.description)
			let urlLocation = encodeURIComponent(this.location)
			let urlRedirect = encodeURIComponent('http://staging.wrkprty.com') // Change!

			if (calendar.id === 'microsoft' || calendar.id === 'apple') {
				let startDate = moment(this.date + ' ' + this.startTime).format(
					'MM/DD/YYYY h:mm:ss a'
				)
				let endDate = moment(this.date + ' ' + this.endTime).format(
					'MM/DD/YYYY h:mm:ss a'
				)
				let cal = ics()
				cal.addEvent(
					this.title,
					this.description,
					this.location,
					startDate,
					endDate
				)
				cal.download(this.title.replace(/ /g, '_'))
			} else if (calendar.id === 'google') {
				let startDate = moment(this.date + ' ' + this.startTime).format(
					'YYYYMMDDTHHmmss'
				)
				let endDate = moment(this.date + ' ' + this.endTime).format(
					'YYYYMMDDTHHmmss'
				)
				let date = startDate + '/' + endDate
				url =
					calendar.url +
					`action=TEMPLATE&dates=${date}&text=${urlTitle}&details=${urlDescription}&location=${urlLocation}&sprop=website:www.wrkprty.com&sprop=name:wrkprty`
			} else if (calendar.id === 'yahoo') {
				let startDate = moment(this.date + ' ' + this.startTime).format(
					'YYYYMMDDTHHmmss'
				)
				let startTime = moment(this.date + ' ' + this.startTime)
				let endTime = moment(this.date + ' ' + this.endTime)
				let dateDiff = moment.duration(endTime.diff(startTime))
				let hours = String('0' + dateDiff.asHours()).slice(-2)
				let duration = hours + '00'

				url =
					calendar.url +
					`ST=${startDate}&DUR=${duration}&TITLE=${urlTitle}&DESC=${urlDescription}&in_loc=${urlLocation}&URL=${urlRedirect}`
			}
			if (url) {
				window.open(
					url,
					'wrkprty ' + calendar.text,
					'height=480,width=640',
					'_blank'
				)
			}
		}
	},
	computed: {
		...mapGetters(['userIsAuthenticated', 'user', 'getModalProp']),
		date() {
			return this.event.date
		},
		startTime() {
			return this.event.time_start
		},
		endTime() {
			return this.event.time_end
		},
		location() {
			let addressComponents = []
			if (this.event.location.address.street_number) {
				addressComponents.push(this.event.location.address.street_number)
			}
			if (this.event.location.address.route) {
				addressComponents.push(this.event.location.address.route)
			}
			if (this.event.location.address.neighborhood) {
				addressComponents.push(this.event.location.address.neighborhood)
			}
			if (this.event.location.address.city) {
				addressComponents.push(this.event.location.address.city)
			}
			if (this.event.location.address.state) {
				addressComponents.push(this.event.location.address.state)
			}
			if (this.event.location.address.state) {
				if (this.event.location.address.state !== 'United States') {
					addressComponents.push(this.event.location.address.state)
				}
			}
			let addressString = ''
			for (var i = 0; i < addressComponents.length; i++) {
				addressString += addressComponents[i]
				if (i < addressComponents.length - 1) {
					addressString += ', '
				}
			}
			return addressString
		},
		description() {
			return this.event.description
		},
		title() {
			return this.event.title
		},
		addToCalendarModalOpen: {
			get() {
				return this.getModalProp('calendarModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'calendarModal', value: val })
			}
		},
		event() {
			return this.getModalProp('calendarModalEvent')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
